// getMeStories.js
'use strict';
import {
  OUTBOX_FEED_STORY,
  OUTBOX_FEED_STORY_SORTINGS,
} from '../RemoteConfigKeys.js';

import createCachedSelector from '../resource/createCachedSelector.js';

import getStoryPreviewIds from '../selector/getStoryPreviewIds.js';
import getMeData from '../selector/getMeData.js';
import getListData from '../selector/getListData.js';
import getFeedName from '../selector/getFeedName.js';
import { getSelectedQueryOptionObject } from '../selector/getFeedQueryObject.js';
import getSelectedFeedQueryOptions from '../selector/getSelectedFeedQueryOptions.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';

const defaultArray = [];

/**
 * Select me stories and upload stories data.
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {string} dataKey - data key.
 * @return {any} The selected date.
 */
const getMeStories = createCachedSelector(
  (state, dataKey) => {
    const meId = getMeData(state, 'id');
    const outboxStoryFeedName = getFeedName(
      state,
      OUTBOX_FEED_STORY,
      '{USER_ID}',
      meId
    );
    const { intersectedFeedName } = getSelectedQueryOptionObject(
      state,
      outboxStoryFeedName,
      getSelectedFeedQueryOptions(state, OUTBOX_FEED_STORY, undefined),
      getRemoteConfigData(state, OUTBOX_FEED_STORY_SORTINGS)?.[0]
    );
    return getListData(
      state,
      ['home', 'messages', intersectedFeedName],
      dataKey
    );
  },
  state => getStoryPreviewIds(state),
  (state, dataKey) => dataKey,
  (meResult, storyPreviewIds = defaultArray, dataKey) => {
    if ('itemIds' === dataKey) {
      const meStoryIds = meResult || [];
      return [...storyPreviewIds, ...meStoryIds];
    }
    if ('totalCount' === dataKey) {
      const meStoryCount = meResult || 0;
      return storyPreviewIds.length + meStoryCount;
    }
  }
)((state, dataKey) => `${dataKey}`);

export default getMeStories;
